export default "__VITE_ASSET__BnnEFJmS__"